// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2b-OZ","bigColWidth":"Table_bigColWidth__3HY_e","biggerColWidth":"Table_biggerColWidth__3a8zn","row":"Table_row__JXbrQ","col":"Table_col__3qynW"};